import { useEffect, useState } from 'react';
import { Utils } from '../../Utils.js';
import TypedLink from '../TypedLink/TypedLink.js';
import i18n from '../../i18n/i18n.js';
import './SystemPageLinks.css';

/**
 * A szerver által visszaadott érték lehet:
 *  - teljes URL: https://szepsegcikk.hu/content/altalanos-szerzodesi-feltetelek
 *  - útvonal: /content/altalanos-szerzodesi-feltetelek
 *  - puszta slug: altalanos-szerzodesi-feltetelek
 * Minden esetből TypedLink-kompatibilis { type, url } objektumot állít elő.
 * Az ismert kulcsokhoz (KEY_TYPES) rögzített route-típust használ.
 */
const KEY_TYPES = {
  terms_and_conditions: 'content',
  privacy_policy:       'content',
  contact:              'contact',
};

function urlToTypedLink(key, value) {
  if (!value) return null;

  // Ha ismert kulcs, a route típusa fix
  if (KEY_TYPES[key]) {
    const type = KEY_TYPES[key];

    // contact esetén a slug a contact route-on belüli path; query stringet megőrizzük
    if (type === 'contact') {
      const qIdx = value ? value.indexOf('?') : -1;
      return { type, url: qIdx !== -1 ? value.slice(qIdx) : '' };
    }

    // Teljes URL vagy útvonal esetén kivonjuk a type utáni részt
    if (value.startsWith('http') || value.startsWith('/')) {
      try {
        const parsed = new URL(value);
        const pathname = value.startsWith('http')
          ? parsed.pathname + parsed.search
          : value;
        const parts = pathname.replace(/^\//, '').split('/');
        // Ha az első szegmens egyezik a típussal, a maradék az url
        if (parts[0] === type) {
          return { type, url: parts.slice(1).join('/') };
        }
        return { type, url: parts.join('/') };
      } catch {
        // fallthrough
      }
    }

    // Puszta slug → content/{slug}
    return { type, url: value };
  }

  // Ismeretlen kulcs: általános feldolgozás
  try {
    const parsed2 = new URL(value);
    const pathname = value.startsWith('http')
      ? parsed2.pathname + parsed2.search
      : value;
    const parts = pathname.replace(/^\//, '').split('/');
    return { type: parts[0] || '', url: parts.slice(1).join('/') };
  } catch {
    const parts = value.replace(/^\//, '').split('/');
    return { type: parts[0] || '', url: parts.slice(1).join('/') };
  }
}

const LINK_LABELS = {
  terms_and_conditions: () => i18n.t('systemPageLinksTermsAndConditions'),
  privacy_policy:       () => i18n.t('systemPageLinksPrivacyPolicy'),
  contact:              () => i18n.t('systemPageLinksContact'),
};

const SystemPageLinks = ({ className = '' }) => {
  const [links, setLinks] = useState({});

  useEffect(() => {
    Utils.get_server_data('', { ajax_event: 'get_system_page_urls' })
      .then((res) => {
        if (res?.system_page_urls) {
          setLinks(res.system_page_urls);
        }
      });
  }, []);

  const entries = Object.entries(links).filter(([, url]) => !!url);

  if (!entries.length) return null;

  return (
    <ul className={`system_page_links ${className}`.trim()}>
      {entries.map(([key, url]) => {
        const link = urlToTypedLink(key, url);
        if (!link) return null;
        const label = LINK_LABELS[key] ? LINK_LABELS[key]() : key;
        return (
          <li key={key}>
            {/* A labelt <span>-be csomagoljuk, mert a TypedLink string child esetén
                .map()-et hívna rá (a string .length truthy, de nem array) */}
            <TypedLink link={link}><span>{label}</span></TypedLink>
          </li>
        );
      })}
    </ul>
  );
};

export default SystemPageLinks;
